import api from '../utils/api';

/**
 * Service API pour la gestion des zones
 */

// Récupérer toutes les zones
export const getAllZones = async () => {
    const response = await api.get('/zones');
    return response.data;
};

// Récupérer une zone par ID
export const getZoneById = async (id) => {
    const response = await api.get(`/zones/${id}`);
    return response.data;
};

// Récupérer les zones d'un commercial
export const getZonesByCommercial = async (commercialId) => {
    const response = await api.get(`/zones/commercial/${commercialId}`);
    return response.data;
};

// Récupérer les zones actives uniquement
export const getActiveZones = async () => {
    const response = await api.get('/zones/active');
    return response.data;
};

// Créer une nouvelle zone
export const createZone = async (zoneData) => {
    const response = await api.post('/zones', zoneData);
    return response.data;
};

// Mettre à jour une zone
export const updateZone = async (id, zoneData) => {
    const response = await api.put(`/zones/${id}`, zoneData);
    return response.data;
};

// Supprimer une zone (soft delete)
export const deleteZone = async (id) => {
    const response = await api.delete(`/zones/${id}`);
    return response.data;
};

// Récupérer les revendeurs d'une zone
export const getRetailersByZone = async (id) => {
    const response = await api.get(`/zones/${id}/retailers`);
    return response.data;
};

export default {
    getAllZones,
    getZoneById,
    getZonesByCommercial,
    getActiveZones,
    createZone,
    updateZone,
    deleteZone,
    getRetailersByZone
};